import './SuccessModal.css';

import * as React from 'react';

import Button from '../../Button';
import { IModalProps, Modal } from '../../Modal';

export interface ISuccessProps extends IModalProps {
  successMessage: string | JSX.Element;
  title?: string;
}

const SuccessModal = ({ show, onClose, title, successMessage }: ISuccessProps) => (
  <Modal show={show} className="success-modal" onClose={onClose}>
    <Modal.Header>
      <Modal.Title>
        <h5>{title || 'Success'}</h5>
      </Modal.Title>
      <Button bsClass="close" onClick={onClose}></Button>
    </Modal.Header>
    <Modal.Body>
      <div className="success-text">
        <div>{successMessage}</div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={onClose}>
        OK
      </Button>
    </Modal.Footer>
  </Modal>
);

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/Modals/SuccessModal/SuccessModal.tsx